import { useCallback, useEffect, useState } from 'react';

import {
  TRIAL_PLANS,
  TRIAL_PLAN_NAMES,
  MONTHLY_TERM,
  PODIUM_TRIAL_PLAN,
} from 'screens/Trials/constants';
import useBundlePrice from './useBundlePrice';
import { getCookies } from 'lib/getCookies';

const useTrialPlan = () => {
  const queryBundlePrice = useBundlePrice();

  const [trialPlan, setTrialPlan] = useState(TRIAL_PLANS[PODIUM_TRIAL_PLAN]);
  const [term, setTerm] = useState(MONTHLY_TERM);
  const [loading, setLoading] = useState(true);

  const getBundlePrice = useCallback(async () => {
    try {
      const bundle = getCookies().bundle || PODIUM_TRIAL_PLAN;
      const term = localStorage.getItem('term');

      term && setTerm(term);

      const bundles = await queryBundlePrice(bundle);

      if (bundles[bundle]) {
        setTrialPlan({
          plan: bundle,
          displayName: TRIAL_PLAN_NAMES[bundle],
          monthlyPrice: bundles[bundle].monthlyPrice,
          annualPrice: bundles[bundle].annualPrice,
        });
      } else {
        setTrialPlan(TRIAL_PLANS[PODIUM_TRIAL_PLAN]);
      }
    } catch (error) {
      console.log(`error in bundle price: ${error}`);

      return setTrialPlan(TRIAL_PLANS[PODIUM_TRIAL_PLAN]);
    }
  }, [queryBundlePrice]);

  useEffect(() => {
    getBundlePrice().then(() => setLoading(false));

    return () => setLoading(false);
  }, [getBundlePrice]);

  return { loading, term, trialPlan };
};

export default useTrialPlan;
